/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

//helpers
import { renderFullName } from "./staffHelpers";

// style rules
import { Animation, Typography } from "../../styles";

const StaffCard = ({ toggleModal, staffMember }) => {
	return (
		<Card
			initial={"initial"}
			animate={"animate"}
			exit={"initial"}
			variants={Animation.cards.opacityVariants}
			onClick={() => toggleModal(staffMember)}
		>
			<AspectRatioBox>
				{staffMember.image ? (
					<img src={staffMember.image} alt={`Image for ${staffMember.title}`} />
				) : (
					<img
						src={
							mainScript.assetPath + "images/png/graphics/ar-placeholder@2x.png"
						}
						alt={"Staff member card placeholder"}
					/>
				)}
			</AspectRatioBox>
			<Title dangerouslySetInnerHTML={{ __html: renderFullName(staffMember) }} />
			{staffMember.job_title && <JobTitle>{staffMember.job_title}</JobTitle>}
		</Card>
	);
};

export default StaffCard;

StaffCard.propTypes = {
	staffMember: PropTypes.object,
	toggleModal: PropTypes.func,
};

const Card = styled(motion.li)`
	list-style: none;
	cursor: pointer;

	&:hover {
		img {
			transition: all 0.5s;
			transform: scale(1.1);
		}
	}
`;

const AspectRatioBox = styled.div`
	position: relative;
	width: 100%;
	display: block;
	overflow: hidden;
	padding-top: calc(302 / 302 * 100%);
	border-radius: 20px;

	> img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
		transition: all 0.5s;
	}
`;

const JobTitle = styled.span`
	display: block;
	padding-top: 0.5rem;
	font-weight: ${Typography.fontWeight.regular};
	font-size: 1.6rem;
	line-height: 2rem;
	text-transform: capitalize;
`;

const Title = styled.h3`
	padding-top: 1.1rem;
	font-size: 1.8rem;
	line-height: 2.4rem;
`;
